<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Foreword</a></p>
<p class="toc sub"><a href="#/front03">Introduction</a></p>
<p class="toc"><a href="#/c01">JENNY BHATT: Return to India</a></p>
<p class="toc"><a href="#/c02">CHRISTOPHER BOLLEN: SWAJ</a></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">NIKKI DOLSON: Neighbors</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">E. GABRIEL FLORES: Mala Suerte</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">ALISON GAYLIN: Where I Belong</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">GAR ANTHONY HAYWOOD: With Footnotes and References</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">RAVI HOWARD: The Good Thief</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">GABINO IGLESIAS: Everything Is Going to Be Okay</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">CHARIS JONES: Green-Eyed Monster</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">PRESTON LANG: Potato Sandwich Days</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">AYA DE LEÓN: Frederick Douglass Elementary</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">KRISTEN LEPIONKA: Infinity Sky</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">LAURA LIPPMAN: Slow Burner</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">JOANNA PEARSON: Mr. Forble</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">DELIA C. PITTS: The Killer</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">ELIOT SCHREFER: Wings Beating</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">ALEX SEGURA: 90 Miles</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">BRIAN SILVERMAN: Land of Promise</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">FAYE SNOWDEN: One Bullet. One Vote.</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">LISA UNGER: Let Her Be</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Contributors’ Notes</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Other Distinguished Mystery and Suspense of 2020</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Read More from the Best American Series</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">About the Editors</span></p>
<p class="toc sub"><span href="#/back05" title="Link target outside of Sample">Connect on Social Media</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5cc20388